import { z } from 'zod';

const PeopleChartFilterOption = z
	.object({
		id: z
			.union([z.number(), z.string()])
			.transform((id) => String(id))
			.pipe(z.string()),
		name: z.string(),
	})
	.transform(({ id, name }) => ({
		value: id,
		label: name,
	}));

const PeopleChartFilterSingleOption = z.string().transform((value) => {
	return {
		value,
		label: value,
	};
});

export const PeopleChartFilterOptionsSchema = z.object({
	areaBoard: z.array(PeopleChartFilterSingleOption).default([]),
	management: z.array(PeopleChartFilterSingleOption).default([]),
	coordination: z.array(PeopleChartFilterSingleOption).default([]),
	employee: z.array(PeopleChartFilterSingleOption).default([]),
});

export type PeopleChartFiltersOptions = z.infer<
	typeof PeopleChartFilterOptionsSchema
>;

const RoleChartFilterOption = z
	.object({
		id: z
			.union([z.number(), z.string()])
			.transform((id) => String(id))
			.pipe(z.string()),
		name: z.string(),
	})
	.transform(({ id, name }) => ({
		value: id,
		label: name,
	}));

const RoleChartFilterSingleOption = z.string().transform((value) => {
	return {
		value,
		label: value,
	};
});

export const RoleChartFilterOptionsSchema = z.object({
	companies: z.array(RoleChartFilterOption).default([]),
	boards: z.array(RoleChartFilterOption).default([]),
	managements: z.array(RoleChartFilterOption).default([]),
	coordinations: z.array(RoleChartFilterOption).default([]),
	employees: z.array(RoleChartFilterOption).default([]),
});

export type RoleChartFiltersOptions = z.infer<
	typeof RoleChartFilterOptionsSchema
>;
